import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect, useRef, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
import {
  Button,
  ConfigProvider,
  Divider,
  List,
  Modal,
  Popconfirm,
  Radio,
  Table,
  message,
} from "antd";
import CanvasDraw from "react-canvas-draw";
import { DeleteOutlined } from "@ant-design/icons";
import ReactCrop from "react-image-crop";
import CustomButton from "../../../component/CustomButton";
import { debounce } from "lodash";
import { FaRegHand } from "react-icons/fa6";
import { RxCrosshair2 } from "react-icons/rx";
import { BsFillPatchPlusFill, BsPatchMinusFill } from "react-icons/bs";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import Draggable from "react-draggable";
import { math } from "@tensorflow/tfjs";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const AnalysisPeriapicalLesion = (props) => {
  const { id, idAnalyses } = useParams();
  let navigate = useNavigate();

  const canvasRef = useRef(null);
  const canvasCropRef = useRef(null);

  const SvgRef = useRef(null);

  const [mousePosition, setMousePosition] = useState({ x: null, y: null });

  const [during_Draw_mousePosition, set_during_Draw_MousePosition] = useState({
    x: null,
    y: null,
  });

  const [isNewDrawing, setIsNewDrawing] = useState(false);

  const [startPointState, setStartPointState] = useState({ x: null, y: null });

  const [DisableDrage, setDisbaleDrage] = useState(false);

  const [editMode, setEditmode] = useState(false);
  const [objEdit, setObjEdit] = useState(null);

  const [_Photo, setPhoto] = useState(null);
  const [listRectangle, setListRectangle] = useState([]);
  const [scale, setScale] = useState(1);

  const [_showModalSelectClass, setshowModalSelectClass] = useState(false);
  const [objectLabel, setObjectLabel] = useState(null);
  const [NumberTooth, setNumberTooth] = useState(null);
  const [ToothIntact, setToothIntact] = useState(null);

  useEffect(() => {
    // GetOpgPhoto();
    if (idAnalyses) {
      GetPatientPhotoForEdit();
    } else {
      GetPatientPhoto();
    }
  }, []);

  useEffect(() => {
    console.log(listRectangle);
    if (listRectangle.length > 0) {
      _drawList();
    }
  }, [listRectangle]);

  useEffect(() => {
    const canvasCrop = canvasCropRef.current;
    if (canvasCrop == null) {
      return;
    }
    const ctxCrop = canvasCrop.getContext("2d");

    var imageObj1 = new Image();
    imageObj1.src = ImagePreAddress + _Photo?.imageUrl;
    imageObj1.onload = function () {
      ctxCrop.drawImage(
        imageObj1,
        objectLabel.x * (1 / scale),
        objectLabel.y * (1 / scale),
        objectLabel.width * (1 / scale),
        objectLabel.height * (1 / scale),
        0,
        0,
        objectLabel.width * (1 / scale),
        objectLabel.height * (1 / scale)
      );
    };
  }, [objectLabel]);
  const GetPatientPhoto = async () => {
    let url = Url.GetPhotoForPeriapicalLesion;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setPhoto(res?.data);
  };

  const GetPatientPhotoForEdit = async () => {
    let url = Url.GetPhotoForPeriapicalLesionEdit;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: parseInt(idAnalyses),
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setPhoto(res?.data?.patientImage);

    let RectangleList = [];

    if (res?.data?.patientImage?.periapicalLesionAnalysis.length <= 0) {
      return;
    }
    RectangleList =
      res?.data?.patientImage?.periapicalLesionAnalysis[0]?.periapicalLesionAnalysisDetails?.map(
        (o) => {
          let obj = {};
          obj.uid = uuidv4();
          obj.x = o.x1 * scale;
          obj.y = o.y1 * scale;
          obj.width = Math.abs(o.x2 - o.x1) * scale;
          obj.height = Math.abs(o.y2 - o.y1) * scale;

          obj.X1 = obj.x;
          obj.Y1 = obj.y;
          obj.X2 = obj.X1 + obj.width;
          obj.Y2 = obj.Y2 + obj.height;

          obj.type = o.type;
          obj.intact = o.type;

          return obj;
        }
      );

    setListRectangle(RectangleList);
  };

  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const _drawList = () => {};

  const returnNumberTeethButton = () => {
    const _onChangeNumberTooth = (number) => {
      if (ToothIntact == null) {
        message.warn("نوع دندان مشخص شود");
        return;
      }
      let newList = [...listRectangle];
      objectLabel.type = number;
      objectLabel.intact = ToothIntact;
      let findIndex = newList.findIndex((obj) => obj.uid == objectLabel.uid);
      if (findIndex >= 0) {
        newList[findIndex] = objectLabel;
      } else {
        newList.push(objectLabel);
      }

      setListRectangle(newList);
      setNumberTooth(number);
      setshowModalSelectClass(false);
    };

    const _onClickSubmit = (_type) => {
      if (_type == null) {
        message.warn("نوع دندان مشخص شود");
        return;
      }

      let newList = [...listRectangle];
      objectLabel.intact = _type;
      let findIndex = newList.findIndex((obj) => obj.uid == objectLabel.uid);
      if (findIndex >= 0) {
        newList[findIndex] = objectLabel;
      } else {
        newList.push(objectLabel);
      }

      setListRectangle(newList);
      setshowModalSelectClass(false);
    };
    return (
      <div className="text-center">
        <canvas
          ref={canvasCropRef}
          width={objectLabel?.width * (1 / scale)}
          height={objectLabel?.height * (1 / scale)}
          // style={{ backgroundColor: "red" }}
        />
        <div>
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            size="small"
            value={ToothIntact}
            onChange={(e) => {
              _onClickSubmit(e.target.value);
              // setToothIntact(e.target.value)
            }}
          >
            <Radio style={{ width: 100 }} value="intact">
              سالم
            </Radio>
            <Radio style={{ width: 100 }} value="Notintact">
              ضایعه پری اپیکال
            </Radio>
          </Radio.Group>
        </div>
        {/* <Button
          type="primary"
          style={{ marginTop: 20 }}
          onClick={_onClickSubmit}
        >
          Submit
        </Button> */}
      </div>
    );
  };

  const returnSideBar = () => {
    return (
      <div dir="ltr" className="sidebar">
        <div>
          <div className=" margin-horizontal10 flex-row justify-between">
            <div>
              <FaRegHand
                onClick={() => setEditmode(true)}
                color={editMode ? "green" : "black"}
              />
            </div>
            <div>
              <RxCrosshair2
                onClick={() => setEditmode(false)}
                color={!editMode ? "green" : "black"}
              />
            </div>
          </div>

          <div className="margin-horizontal10">Labels</div>

          <div>
            <ConfigProvider direction="ltr">
              {listRectangle.length > 0 && (
                <List
                  split
                  size="small"
                  dataSource={listRectangle}
                  renderItem={_renderSideBarItem}
                />
              )}
            </ConfigProvider>
          </div>
        </div>
        <div>
          <CustomButton
            onClick={_getWithAi}
            title="Get With Ai !"
            isLoading={
              props.coreData[Url.PredictTeeth + id]?.[Url.action]?.isFetching
            }
          />
          <CustomButton
            onClick={_onClickSubmit}
            title="Submit"
            isLoading={
              props.coreData[Url.saveAnalysisForPeriapicalLesion]?.[Url.action]
                ?.isFetching
            }
          />
        </div>
      </div>
    );
  };
  const _renderSideBarItem = (item, index) => {
    const Delete = () => {
      let newList = [...listRectangle];
      newList = newList.filter((o) => o.uid !== item.uid);
      setListRectangle(newList);
    };
    let color = "pink";
    if (item.intact == "intact") {
      color = "#2db7f5";
    }
    if (item.intact == "Notintact") {
      color = "#f50";
    }

    const onClickChangeSize = (dir, operation) => {
      let newList = [...listRectangle];
      let findindex = newList.findIndex((obj) => obj.uid == item.uid);
      if (findindex >= 0) {
        if (dir == "x") {
          if (operation == "+") {
            newList[findindex] = {
              ...newList[findindex],
              width: newList[findindex].width + 5,
            };
          }
          if (operation == "-") {
            newList[findindex] = {
              ...newList[findindex],
              width: newList[findindex].width - 5,
            };
          }
        }
        if (dir == "y") {
          if (operation == "+") {
            newList[findindex] = {
              ...newList[findindex],
              height: newList[findindex].height + 5,
            };
          }
          if (operation == "-") {
            newList[findindex] = {
              ...newList[findindex],
              height: newList[findindex].height - 5,
            };
          }
        }
      }

      setListRectangle(newList);
    };
    return (
      <div>
        <div className="margin-horizontal10 sliderText ">
          <div
            style={{ backgroundColor: color, marginTop: 2 }}
            className="flex-row justify-between "
          >
            <div className="imgdragdisable margin-horizontal10">
              {item.type}
            </div>
            <div className="flex-row justify-center align-center">
              <div className="imgdragdisable" style={{ marginRight: 2 }}>
                X
              </div>

              <div>
                <FaPlusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("x", "+")}
                />
              </div>
              <div>
                <FaMinusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("x", "-")}
                />
              </div>

              <div
                className="imgdragdisable"
                style={{ marginLeft: 10, marginRight: 2 }}
              >
                Y
              </div>
              <div>
                <FaPlusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("y", "+")}
                />
              </div>
              <div>
                <FaMinusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("y", "-")}
                />
              </div>
            </div>
            <div className="margin-horizontal10">
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={Delete}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined />
              </Popconfirm>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const _onClickSubmit = async () => {
    for (let index = 0; index < listRectangle.length; index++) {
      const element = listRectangle[index];
      if (element.type == "") {
        message.warn("لطفا نوع دندان را مشخص کنید");
        return;
      }
    }

    let newlist = [...listRectangle];
    let finalList = [];

    finalList = newlist.map((o) => {
      let newO = {};
      newO.H = Math.floor(o.height * (1 / scale));
      newO.W = Math.floor(o.width * (1 / scale));
      newO.x = Math.floor(o.x * (1 / scale));
      newO.y = Math.floor(o.y * (1 / scale));

      newO.X1 = Math.floor(o.x * (1 / scale));
      newO.Y1 = Math.floor(o.y * (1 / scale));

      newO.X2 = newO.X1 + newO.W;
      newO.Y2 = newO.Y1 + newO.H;

      newO.type = o.intact;
      newO.intact = o.intact;

      return newO;
    });

    let _toServer = {
      id: idAnalyses ? idAnalyses : 0,
      patientId: _Photo.patientId,
      PatientImageId: _Photo.id,
      PeriapicalAnalysisDetails: finalList,
    };

    let url = Url.saveAnalysisForPeriapicalLesion;

    let res = await props.actions.CallCoreServicesActionWithToken(
      url,
      _toServer
    );

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    message.success(res.message);
    navigate("/periapicallesion/mainpage");
  };

  const _returnSvgElemtent = () => {
    let _output = [];

    _output.push(<rect id="newRect" width="0" height="0" x="0" y="0" />);

    let addCss = " ";
    if (editMode) {
      addCss += " rectEdit ";
    }

    const OnStopDragable = (evn, data, object) => {
      console.log(object);
      let newList = [...listRectangle];
      let findindex = newList.findIndex((obj) => obj.uid == object.uid);
      if (findindex >= 0) {
        newList[findindex] = { ...newList[findindex], x: data.x, y: data.y };
      }
      setListRectangle(newList);
    };
    listRectangle.forEach((o) => {
      let color = "pink";
      if (o.intact == "intact") {
        color = "#2db7f5";
      }
      if (o.intact == "Notintact") {
        color = "#f50";
      }
      _output.push(
        <>
          <Draggable
            disabled={!editMode}
            onStop={(env, data) => OnStopDragable(env, data, o)}
            position={{ x: o.x, y: o.y }}
            scale={1}
            // bounds="parent"
          >
            <g>
              <rect
                onDoubleClick={(ev) => {
                  setObjectLabel(o);
                  setNumberTooth(o.type);
                  setToothIntact(o.intact);
                  setshowModalSelectClass(true);
                }}
                className={addCss}
                id={o.uid}
                width={o.width}
                height={o.height}
                x={0}
                y={0}
                fill="transparent"
                stroke={color}
                strokeWidth={2}
              ></rect>
              <text className="imgdragdisable" x={0} y={10} fill="black">
                {/* {o.type} */}
              </text>
            </g>
          </Draggable>
        </>
      );
    });
    return _output;
  };

  let startPoint = { x: null, y: null };
  const _OnMouseDownSvg = (event) => {
    if (DisableDrage) {
      return;
    }

    if (editMode) {
      return;
    }

    setIsNewDrawing(true);

    const svgRect = SvgRef.current.getBoundingClientRect();
    const mouseX = event.clientX - svgRect.left;
    const mouseY = event.clientY - svgRect.top;
    startPoint = { x: mouseX, y: mouseY };
    setStartPointState(startPoint);

    // console.log("Down", mouseX, mouseY);
  };

  const _onMouseMoveSvg = (event) => {
    if (DisableDrage) {
      return;
    }
    const svgRect = SvgRef.current.getBoundingClientRect();
    const mouseX = event.clientX - svgRect.left;
    const mouseY = event.clientY - svgRect.top;

    // console.log("Move", mouseX, mouseY);

    UpdateRect(mouseX, mouseY);
  };

  const _onMouseUpSvg = (event) => {
    if (DisableDrage) {
      return;
    }
    if (editMode) {
      return;
    }

    setIsNewDrawing(false);

    startPoint = { x: null, y: null };
    setStartPointState({ x: null, y: null });
    // setStartPointDrawRectangle({ x: null, y: null });

    let rect = SvgRef.current.querySelector("#newRect");
    if (rect) {
      // Get the bounding box of the SVG element
      let x = rect.x.animVal.value;
      let y = rect.y.animVal.value;
      let w = rect.width.animVal.value;
      let h = rect.height.animVal.value;

      let newClass = {
        uid: uuidv4(),
        x: x,
        y: y,
        width: w,
        height: h,
        type: "1R",
      };

      rect.setAttribute("x", 0);
      rect.setAttribute("y", 0);
      rect.setAttribute("width", 0);
      rect.setAttribute("height", 0);

      setObjectLabel(newClass);
      setNumberTooth(null);
      setToothIntact(null);
      setshowModalSelectClass(true);
    }
  };

  const UpdateRect = debounce((MouseX, Mousey) => {
    if (startPointState.x != null && startPointState.y != null) {
      let x = Math.min(startPointState.x, MouseX);
      let y = Math.min(startPointState.y, Mousey);
      let w = Math.abs(MouseX - startPointState.x);
      let h = Math.abs(Mousey - startPointState.y);
      // console.log("Update", x, y, w, h);
      let rect = SvgRef.current.querySelector("#newRect");

      // Update the rectangle attributes
      rect.setAttribute("x", x);
      rect.setAttribute("y", y);
      rect.setAttribute("width", w);
      rect.setAttribute("height", h);
      rect.setAttribute("fill", "none");
      rect.setAttribute("stroke", "black"); // Set border color
      rect.setAttribute("stroke-width", "1");
    }
  }, 1);

  const _getWithAi = async () => {
    message.warning("not implement Ai Yet Dr heydarzade");
    return;
    let url = Url.PredictTeeth + id;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let ListBox = JSON.parse(res?.data);
    let _outPut = [];

    ListBox.forEach((o) => {
      let w = o.w;
      let h = o.h;
      let x = o.x - w / 2;
      let y = o.y - h / 2;

      _outPut.push({
        uid: uuidv4(),
        x: x * scale,
        y: y * scale,
        width: w * scale,
        height: h * scale,
        type: o.type,
        intact: "intact",
      });
    });

    setListRectangle(_outPut);
    setEditmode(true);
  };
  return (
    <div dir="ltr">
      <Modal
        open={_showModalSelectClass}
        onCancel={() => setshowModalSelectClass(false)}
        footer={null}
      >
        {returnNumberTeethButton()}
      </Modal>

      <div className="flex-row" style={{ position: "relative" }}>
        {returnSideBar()}
        {_Photo !== null && (
          <div
            className="text-center"
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div>
              {/* <img
                className="imgdragdisable"
                style={{ maxWidth: 400 }}
                src={
                  ImagePreAddress +
                  props.coreData[Url.GetOpgPhotonumbering]?.[Url.action]?.data
                    ?.imageUrl
                }
              /> */}
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                position: "relative",
                width: _Photo?.imageWidth * scale,
                height: _Photo?.imageHeight * scale,
              }}
            >
              <svg
                ref={SvgRef}
                style={{ zIndex: 1, position: "absolute", top: 0, left: 0 }}
                width={_Photo?.imageWidth * scale}
                height={_Photo?.imageHeight * scale}
                onMouseDown={_OnMouseDownSvg}
                onMouseMove={_onMouseMoveSvg}
                onMouseUp={_onMouseUpSvg}
              >
                {_returnSvgElemtent()}
              </svg>
              <img
                className="imgdragdisable"
                src={ImagePreAddress + _Photo?.imageUrl}
                style={{
                  width: _Photo?.imageWidth * scale,
                  height: _Photo?.imageHeight * scale,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 0,
                }}
              />
            </div>

            {/* <canvas
              dir="ltr"
              ref={canvasRef}
              width={_Photo?.imageWidth * scale}
              height={_Photo?.imageHeight * scale}
              style={{
                backgroundImage:
                  "url('" + ImagePreAddress + _Photo?.imageUrl + "')",
                backgroundSize: "cover",
                cursor: "crosshair",
                width: _Photo?.imageWidth * scale,
                height: _Photo?.imageHeight * scale,
              }}
              onMouseMove={_onMouseMove}
              onMouseDown={_onMouseDown}
              onMouseUp={_onMouseUp}
            /> */}

            <img
              style={{ display: "none" }}
              id="imageOriginal"
              src={ImagePreAddress + _Photo?.imageUrl}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalysisPeriapicalLesion);
